// Copyright (c) 2018 Deere & Company

export const getRequestIcon = requestType => {

    const iconClass = {
        INFO: 'icon-info',
        PART: 'icon-truck-small',
        PICT: 'icon-pict'
    };

    return iconClass[requestType] ?
        iconClass[requestType] :
        iconClass.PART;

};



// WEBPACK FOOTER //
// ./src/part-requests/shared/services/get-request-icon.js